import React, { Component } from "react"
import { SketchPicker } from "react-color"

class ColorPicker extends Component {
	constructor(props) {
		super(props)
		this.state = {
			open: false,
		}
	}

	handleChange = (v) => {
		this.props.onChange(v.hex)
	}

	render() {
		return (
			<div style={{ position: "absolute", top: 0, right: 0 }}>
				<i
					className="far fa-palette"
					style={{ cursor: "pointer" }}
					onClick={() => this.setState({ open: !this.state.open })}></i>
				{this.state.open && (
					<div style={{position:'absolute', top:0, left:50, zIndex:100}}>
						<SketchPicker color={this.props.value} onChangeComplete={this.handleChange} />
					</div>
				)}
			</div>
		)
	}
}

export default ColorPicker
